import React from 'react';
import './FontProvider.css';
import PropTypes from 'prop-types';

// Import all stylesheets up front to assist with roster printing,
//   as the styles need to be in the head before the print occurs
// Font files don't load until used
import './kiddie/kiddie.css';
import './middle/middle.css';
import './teacher/teacher.css';

export const KIDDIE = 'kiddie';
export const MIDDLE = 'middle';
export const TEACHER = 'teacher';

export class FontProvider extends React.Component {
  static propTypes = {
    fontKey: PropTypes.string.isRequired,
  };

  render() {
    const classes = ['FontProvider'];
    if (this.props.fontKey) {
      classes.push(`FontProvider--${this.props.fontKey}`);
    }

    return <div className={classes.join(' ')}>{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/fonts/FontProvider.js